export const VARIANT_PRIMARY = 'primary';
export const VARIANT_SUBTLE = 'subtle';
export const VARIANT_INVERTED = 'inverted';

export type IconButtonVariant =
  | typeof VARIANT_PRIMARY
  | typeof VARIANT_SUBTLE
  | typeof VARIANT_INVERTED;
